export interface PtChart {
    pressures:number[]  // PSIG
    satTemps:number[]   // °F
}

// Pressure-temperature saturation data for common refrigerants.
// Pressures in PSIG, saturation temperatures in °F.
// Values sourced from ASHRAE / refrigerant manufacturer PT charts.
// Rows are sorted ascending by pressure.
const R410A:PtChart = {
    pressures: [
        29, 38, 49, 61, 75, 91, 110, 130, 153, 178,
        206, 237, 271, 308, 349, 393, 441, 494, 551, 612,
    ],
    satTemps: [
        -40, -35, -30, -25, -20, -15, -10, -5, 0, 5,
        10, 15, 20, 25, 30, 35, 40, 45, 50, 55,
    ],
}

const R22:PtChart = {
    pressures: [
        11, 15, 21, 27, 34, 43, 53, 64, 76, 90,
        106, 124, 143, 165, 188, 215, 243, 274, 307, 343,
    ],
    satTemps: [
        -40, -35, -30, -25, -20, -15, -10, -5, 0, 5,
        10, 15, 20, 25, 30, 35, 40, 45, 50, 55,
    ],
}

const R134a:PtChart = {
    pressures: [
        -6.5, -4, -1, 3, 7, 11, 17, 23, 30, 37,
        45, 54, 64, 76, 89, 103, 119, 136, 155, 176,
    ],
    satTemps: [
        -40, -35, -30, -25, -20, -15, -10, -5, 0, 5,
        10, 15, 20, 25, 30, 35, 40, 45, 50, 55,
    ],
}

const R404A:PtChart = {
    pressures: [
        24, 31, 40, 51, 63, 77, 93, 111, 131, 154,
        179, 207, 237, 271, 308, 347, 390, 437, 487, 542,
    ],
    satTemps: [
        -40, -35, -30, -25, -20, -15, -10, -5, 0, 5,
        10, 15, 20, 25, 30, 35, 40, 45, 50, 55,
    ],
}

export const PT_CHARTS:Record<string, PtChart> = {
    'R-410A': R410A,
    'R-22': R22,
    'R-134a': R134a,
    'R-404A': R404A,
}

function interpolate (
    xs:number[],
    ys:number[],
    x:number
):number | null {
    const n = xs.length
    if (x < xs[0] || x > xs[n - 1]) return null
    for (let i = 0; i < n - 1; i++) {
        if (x >= xs[i] && x <= xs[i + 1]) {
            const t = (x - xs[i]) / (xs[i + 1] - xs[i])
            return ys[i] + t * (ys[i + 1] - ys[i])
        }
    }
    return null
}

export function satTempFromPressure (
    refrigerantId:string,
    pressurePsig:number
):number | null {
    const chart = PT_CHARTS[refrigerantId]
    if (!chart) return null
    return interpolate(chart.pressures, chart.satTemps, pressurePsig)
}

export function pressureFromSatTemp (
    refrigerantId:string,
    satTempF:number
):number | null {
    const chart = PT_CHARTS[refrigerantId]
    if (!chart) return null
    return interpolate(chart.satTemps, chart.pressures, satTempF)
}
